import React, { useMemo } from "react";
import { AiOutlineHome, AiOutlineSchedule } from "react-icons/ai";
import { BsArrowLeft } from "react-icons/bs";
import { IoPeopleOutline } from "react-icons/io5";
import PresentationReminder from "./PresentationReminder";
import SidebarIcon from "./SidebarIcon";
import { useTenant, useUser, useVenue } from "../api/helpers";
import LightTheme from "../theme/LightTheme";

const toSchedule = { hash: "#schedule" };

const Sidebar = () => {
  const user = useUser();
  const venue = useVenue();
  const tenant = useTenant();

  const toHome = useMemo(
    () => ({ pathname: `/${venue?.accessCode}`, hash: "#home" }),
    [venue?.accessCode],
  );
  const toPartners = useMemo(
    () => ({ pathname: `/${venue?.accessCode}`, hash: "#partners" }),
    [venue?.accessCode],
  );

  if (!user || !venue) {
    return null;
  }
  return (
    <div className="sidebarWrapper">
      <PresentationReminder />
      <nav className="navWrapper stickySide">
        <div>
          <SidebarIcon text="Home" linkTo={toHome}>
            <AiOutlineHome size={30} />
          </SidebarIcon>
          <SidebarIcon text="Schedule" linkTo={toSchedule}>
            <AiOutlineSchedule size={30} />
          </SidebarIcon>
          <SidebarIcon text="Partners" linkTo={toPartners}>
            <IoPeopleOutline size={35} />
          </SidebarIcon>
          {/* <SidebarIcon text="Expo" linkTo={toExpo}> */}
          {/*  <BsShopWindow size={35} /> */}
          {/* </SidebarIcon> */}
        </div>
        <SidebarIcon text="Exit" linkTo={`/Event/${venue.accessCode}`}>
          <BsArrowLeft size={35} />
        </SidebarIcon>
      </nav>
      <style jsx>
        {`
          .colorLine {
            height: 80px;
            width: 4px;
            background: ${tenant?.color};
          }

          nav {
            padding: 20px 0 0 0;
            background: #fdfefe;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            height: 100%;
          }

          .sidebarWrapper {
            display: flex;
            flex-direction: column;
            box-shadow: ${LightTheme.contentBorderBoxShadow};
            z-index: 2;
          }
        `}
      </style>
    </div>
  );
};

export default Sidebar;
